import React, { useEffect } from "react";
import { useQuery } from "react-query";
import { useDispatch } from "react-redux";
import { setShellConfig } from "../../redux/styleConfig/styleSlice";
import axios from "axios";
import { setupAxios } from "../../../redux";

interface AppStyleProps {
  children: React.ReactNode;
}

const AppStyle = ({ children }: AppStyleProps) => {
  const { data: jsonFile } = useQuery(
    "shellConfig",
    async () => {
      const response = await fetch(`${process.env.REACT_APP_SHELL_CONFIG}`);
      return response.json();
    },
    {
      staleTime: 1000 * 60 * 30,
      cacheTime: 1000 * 60 * 60,
      refetchOnWindowFocus: false,
    }
  );
  const dispatch = useDispatch();
  // remove extra dependency to setupAxios
  useEffect(() => {
    setupAxios(axios);
  }, []);

  useEffect(() => {
    if (jsonFile) {
      dispatch(setShellConfig(jsonFile));
    }
  }, [jsonFile, dispatch]);
  const css = `
  .SuccessDefault{
   background: ${jsonFile?.mainColor} !important;
  }
  
  .MainheaderTitleColor{
   color: ${jsonFile?.mainheaderTitleColor} !important;
  }
  
  .disabledBtn{
   background: ${jsonFile?.secondColor} !important;
  }
  .mainColor-100{
   color: ${jsonFile?.mainColor_100} !important;
  }
  
  .bgMainColor-100{
   background: ${jsonFile?.mainColor_100} !important;
  }
  .secondColor_100{
   color: ${jsonFile?.secondColor_100} !important;
  }
  
  .bgSecondColor_100{
   background: ${jsonFile?.secondColor_100} !important;
  }
  .mainColor-200{
   color: ${jsonFile?.mainColor_200} !important;
  }
  
  .bgMainColor-200{
   background: ${jsonFile?.mainColor_200} !important;
  }
  .errorColor{
   color: ${jsonFile?.errorColor} !important;
  }
  
  .bgErrorColor{
   background: ${jsonFile?.errorColor} !important;
  }
  .errorColor_100{
   color: ${jsonFile?.errorColor_100} !important;
  }
  
  .bgErrorColor_100{
   background: ${jsonFile?.errorColor_100} !important;
  }
  .warningColor{
   color: ${jsonFile?.warningColor} !important;
  }
  
  .bgWarningColor{
   background: ${jsonFile?.warningColor} !important;
  }
  .SuccessDefaultFont {
   color: ${jsonFile?.mainColor} !important;
 }
  .colorUserProfile{
   color: ${jsonFile?.secondColor} !important;
  }
  .iconProfileBorder{
   border: 2px solid ${jsonFile?.secondColor_100};
   padding: 2px;
  }
  .personIcon{
   color: ${jsonFile?.mainColor};
  }
 
  .colorBorderSvgWallet{
   border: 2px solid ${jsonFile?.mainColor};
  }
 
  .colorTitleWallet{
   color: ${jsonFile?.mainColor};
  }
 
  .borderWalletBtnBottom{
   background: ${jsonFile?.secondColor} !important;
  }

  .badgeMeColor{
    background-color:#fff !important;
    color: ${jsonFile?.mainColor};
  }
  .deactivatedButton {
    background-color:${jsonFile?.secondColor_100} !important;
  }
  
  .deactivatedErrorButton {
    background-color:${jsonFile?.errorColor_100} !important;
  }
  
  .activatedButton {
    background-color: ${jsonFile?.mainColor_300};
    min-width: 50px !important;
  }
  .activatedButton:hover {
    background-color: ${jsonFile?.mainColor_300};
    
  }
  .activatedErrorButton {
    background-color: ${jsonFile?.errorColor};
    min-width: 50px !important;
  }
  .activatedErrorButton:hover {
    background-color: ${jsonFile?.errorColor};
    
  }
 
  .place-image>div>div>div {
    background-color: ${jsonFile?.mainColor} !important;
  }
  
  .fileuploader-modal-container>div>div>div>p {
    background-color: ${jsonFile?.mainColor} !important;
  }
  .fileuploader-modal-container>div>div>div>div>div>div>p {
    background-color: ${jsonFile?.mainColor} !important;
  }
  .fileuploader-modal-container>div>div>div>button {
    background-color: ${jsonFile?.mainColor};
  }
  .fileuploader-modal-container>div>div>div>div>div>div>button {
    background-color: ${jsonFile?.mainColor};
  }
  .dropzone-button:hover {
  background-color: ${jsonFile?.mainColor} !important;
}
  .titleCompleteStepper {
  color: ${jsonFile?.mainColor} !important;
  font-size: 14px;
  font-family: "iranSans" !important;
}
 .titleColor {
  color: ${jsonFile?.mainColor} !important;
}
 .neutralColor {
  color: ${jsonFile?.neutralColor} !important;
}

.lineStepperColor{
  border-left: 2px solid ${jsonFile?.mainColor};
}
  .MuiBadge-colorSecondary {
  background-color: ${jsonFile?.mainColor} !important;
}
  
.Mui-selected {
  background: ${jsonFile?.mainColor} !important;
  color: #fff !important;
}
  `;
  return (
    <>
      <style>{css}</style>
      {children}
    </>
  );
};

export default AppStyle;
